<select class="form-control width50" aria-label="Select agency" title="Agency Name" [(ngModel)]="agencyList" (ngModelChange)="changeAgency($event)" name="AgencyNameList">
  <option role="option" value='' selected>-Select Agency-</option>
  @for (a of agencyList; track a) {
    <option role="option" [value]="a.agencyCode">{{a.agencyCode - a.agencyBureauName}}</option>
  }
</select>